import { render, staticRenderFns } from "./massMessaging.vue?vue&type=template&id=44dd1a1a&scoped=true&"
import script from "./massMessaging.vue?vue&type=script&lang=js&"
export * from "./massMessaging.vue?vue&type=script&lang=js&"
import style0 from "./massMessaging.vue?vue&type=style&index=0&id=44dd1a1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dd1a1a",
  null
  
)

export default component.exports